"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsAndStandingsLocalizedReferenceSchema = void 0;
exports.ResultsAndStandingsLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/results-standings.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ResultsAndStandingsLocalizedReference",
    "description": "A content type that allows to display the results of events or races.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:results-standings"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy1zdGFuZGluZ3Muc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvcmVmZXJlbmNlL2xvY2FsaXplZC9jb250ZW50L3Jlc3VsdHMtc3RhbmRpbmdzLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDJDQUEyQyxHQUFHO0lBQ3pELEtBQUssRUFBRSwyRkFBMkY7SUFDbEcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsdUNBQXVDO0lBQ2hELGFBQWEsRUFBRSx1RUFBdUU7SUFDdEYsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTiwrQkFBK0I7YUFDaEM7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxpR0FBaUc7U0FDN0c7S0FDRjtDQUNGLENBQUEifQ==